const introEnglish = () => (
  {
    title: {
      part1: 'Hey there.',
      part2: 'I\'m Camile',
    },
    presentation: 'I’am a Software Developer',
    description: 'I can help you build a product , feature or website. Look through some of my work and experience! If you like what you see and have a project you need coded, don’t hesitate to contact me.',
    resume: 'Get my resume',
    connect: 'Get in touch',
    links: {
      link1: 'Services',
      link2: 'Recent projects',
      link3: 'Libraries',
      link4: 'About me',
      link5: 'Contact',
    },

  }
);

export default introEnglish;
